import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { configQuery } from '../../utils/config-query';
import { IEmailLogs } from '../../utils/interfaces/email-log';
import { IResponse } from '../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private readonly URI_API = environment.apiConfig.uri + 'ScheduledEmailLog';

  constructor(private readonly httpClient: HttpClient) {}

  getScheduledEmailLogs(
    search: boolean,
    searchString: string = '',
    page: number = 0,
    take: number = 0,
    status: boolean | null = null
  ): Observable<IResponse<IEmailLogs[]>> {
    return this.httpClient
      .get<IResponse<IEmailLogs[]>>(
        `${this.URI_API}${configQuery(
          search,
          searchString,
          page,
          take,
          status
        )}`
      )
      .pipe(
        map((res) => {
          res.data.forEach((emailLog) => {
            const frequency = ['Nenhuma', 'Diário', 'Semanal', 'Mensal'];
            emailLog.frequencyName = frequency[emailLog.frequency];
            emailLog.total = emailLog.countSuccess + emailLog.countFailed;
          });
          return res;
        })
      );
  }

  retryEmail(id: string): Observable<IResponse<any>> {
    return this.httpClient.post<IResponse<any>>(
      `${this.URI_API}/retry/${id}`,
      {}
    );
  }
}
